import api from '../api';

// GraphQL query to get seller by token
export const getSellerByToken = async (token: string) => {
  const query = `
    query GetSellerByToken($token: String!) {
      getSellerByToken(token: $token) {
        success
        message
        data {
          seller_id
          email
          shop_title
          logo_pic
          contact_number
        }
      }
    }
  `;

  try {
    const response = await api.post('', {
      query,
      variables: { token }
    });
    return response.data.data.getSellerByToken;
  } catch (error) {
    console.error('Error fetching seller data by token:', error);
    throw error;
  }
};

// GraphQL mutation to initiate password reset
export const initiatePasswordReset = async (email: string) => {
  const mutation = `
    mutation InitiateSellerPasswordReset($email: String!) {
      initiateSellerPasswordReset(email: $email) {
        success
        message
      }
    }
  `;

  try {
    const response = await api.post('', {
      query: mutation,
      variables: { email }
    });
    return response.data.data.initiateSellerPasswordReset;
  } catch (error) {
    console.error('Error initiating password reset:', error);
    throw error;
  }
};

// GraphQL mutation to reset password
export const resetPassword = async (email: string, token: string, newPassword: string) => {
  const mutation = `
    mutation ResetSellerPassword($email: String!, $token: String!, $newPassword: String!) {
      resetSellerPassword(email: $email, token: $token, newPassword: $newPassword) {
        success
        message
      }
    }
  `;

  try {
    const response = await api.post('', {
      query: mutation,
      variables: { email, token, newPassword }
    });
    return response.data.data.resetSellerPassword;
  } catch (error) {
    console.error('Error resetting password:', error);
    throw error;
  }
};
